var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3742 11.0833C8.42131 11.0833 6.83252 9.49454 6.83252 7.54166C6.83252 5.58879 8.42131 4 10.3742 4C12.3271 4 13.9159 5.58879 13.9159 7.54166C13.9159 9.49454 12.3271 11.0833 10.3742 11.0833Z",
    fill: "#5A6A85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36458 12.5001C5.50875 12.5001 4 14.0089 4 15.8647V18.3438C4 18.6343 4.24083 18.8751 4.53125 18.8751H11.0833V16.573C11.0833 15.2414 12.075 14.1434 13.3571 13.9522C13.5413 13.4139 13.8883 12.9605 14.3346 12.6347C13.6263 12.4321 13.588 12.5001 7.36458 12.5001Z",
    fill: "#5A6A85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7602 15.3333H18.8748V14.8021C18.8748 14.1185 18.3187 13.5625 17.6352 13.5625H15.8643C15.1808 13.5625 14.6248 14.1185 14.6248 14.8021V15.3333H13.7393C13.3908 15.3333 13.0771 15.4785 12.8518 15.7109L16.7498 17.7445L20.6477 15.7109C20.4225 15.4785 20.1087 15.3333 19.7602 15.3333ZM15.6873 15.3333V14.8021C15.6873 14.7043 15.7666 14.625 15.8643 14.625H17.6352C17.7329 14.625 17.8123 14.7043 17.8123 14.8021V15.3333H15.6873Z",
    fill: "#5A6A85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9958 18.8149C16.8421 18.8949 16.6579 18.8949 16.5049 18.8149L12.5 16.7253V19.7605C12.5 20.444 13.056 21.0001 13.7396 21.0001H19.7604C20.444 21.0001 21 20.444 21 19.7605V16.7253L16.9958 18.8149Z",
    fill: "#5A6A85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddJobIcon);
export default __webpack_public_path__ + "static/media/addJobIcon.2e9a20c4eda428ed3cdf5185ad4a0e91.svg";
export { ForwardRef as ReactComponent };